import { Linking, Platform, ScrollView, StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ExpoConstants from 'expo-constants';

import { Button, DefaultLayout, Text, colors, spacing } from '@pletly/ui';

import RocketIcon from './rocket.svg';
import { useAppUpdateInfo } from '../../context';
import { withTranslation } from '../../locales/hoc';

export const UpdateInfo = withTranslation(() => {
	const { t } = useTranslation();
	const { goBack } = useNavigation();
	const { top, bottom } = useSafeAreaInsets();
	const { updateInfo } = useAppUpdateInfo();

	if (updateInfo.status !== 'success' || !updateInfo.availableUpdate) {
		return null;
	}

	const { isRequired, version, releaseNotes } = updateInfo.availableUpdate;

	return (
		<DefaultLayout style={{ paddingTop: top, backgroundColor: colors.black200 }}>
			<View style={styles.header}>
				<RocketIcon height={100} />
			</View>
			<View style={styles.mainContent}>
				<View style={styles.infoTextsContainer}>
					<Text category="h2" align="center">
						{isRequired ? t('update-info.forced.title') : t('update-info.optional.title')}
					</Text>
					<Text category="s2" align="center">
						{isRequired ? t('update-info.forced.message') : t('update-info.optional.message')}
					</Text>
				</View>
				{releaseNotes && (
					<ScrollView style={styles.releaseNotesContainer} alwaysBounceVertical={false}>
						<Text category="h6">{t('update-info.whats-new')}:</Text>
						<View style={styles.releaseNotes}>
							<Text category="c1" appearance="hint">
								{t('update-info.version')}: {version}
							</Text>
							<Text category="p2">{releaseNotes}</Text>
						</View>
					</ScrollView>
				)}
			</View>
			<View style={[styles.actions, { paddingBottom: bottom + spacing(2) }]}>
				<Button color="primary" variant="filled" size="small" onPress={openStore}>
					{t('update-info.update-now')}
				</Button>
				{!isRequired && (
					<Button color="primary" variant="outline" size="small" onPress={goBack}>
						{t('update-info.maybe-later')}
					</Button>
				)}
			</View>
		</DefaultLayout>
	);
});

const getStoreUrl = () => {
	const storeUrl = Platform.select({
		ios: ExpoConstants.expoConfig?.ios?.appStoreUrl,
		android: ExpoConstants.expoConfig?.android?.playStoreUrl,
	});

	if (!storeUrl) {
		throw new Error('Store URL is not defined');
	}

	return storeUrl;
};

const openStore = () => {
	Linking.openURL(getStoreUrl());
};

const styles = StyleSheet.create({
	header: {
		padding: spacing(3),
		paddingBottom: spacing(6),
		alignItems: 'center',
		justifyContent: 'center',
	},
	mainContent: {
		backgroundColor: colors.neutral300,
		flex: 1,
	},
	infoTextsContainer: {
		gap: spacing(2),
		paddingHorizontal: spacing(2),
		justifyContent: 'center',
		flex: 2,
	},
	releaseNotesContainer: {
		padding: spacing(2),
		backgroundColor: colors.background200,
		flex: 1.5,
	},
	releaseNotes: {
		padding: spacing(2),
	},
	actions: {
		backgroundColor: colors.neutral300,
		paddingTop: spacing(2),
		paddingHorizontal: spacing(2),
		gap: spacing(2),
	},
});
